export default function initCompassPageSectionToggle( togglerBlock , mapsBlock ) {
    const togglerContainer = togglerBlock.querySelector('.section-toggler-container');
    const togglerTabs = togglerBlock.querySelectorAll('.section-toggler-tab');
    const filtersContainer = document.createElement('div');

    function init() {
        console.log( "CareerReady :: initCompassPageSectionToggle" );
        if (togglerContainer) {
            togglerContainer.classList.add('bg-white', 'overflow-hidden', 'rounded-xl', 'shadow-lg', 'pb-6', 'mb-8');
        }

        filtersContainer.classList.add('filters-container');
        togglerContainer.appendChild(filtersContainer);

        document.addEventListener('interactiveToolUpdated', onSectionToggled);

        if (mapsBlock.querySelector('.filters-group')) {
            onSectionToggled( null );
        }
    }
    
    function onSectionToggled( event ) {
        filtersContainer.innerHTML = '';
        const filterGroup  = mapsBlock.querySelector( '.filters-group' );

        filterGroup.classList.remove(...filterGroup.classList);
        filtersContainer.appendChild(filterGroup);
    }

    return init();
}
